// extracted by mini-css-extract-plugin
var _1 = "ZGR3moYC3gK00_Kpidiu";
export { _1 as "content" }
